<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">车辆报停</span>
    </p>
    <div style="position: relative; min-height: 350px">
      <Spin v-if="loadingStatus" fix />
      <Form ref="suspendForm" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="报停车辆:">
          <Input v-model="vehicleNumber" size="small" disabled />
        </FormItem>
        <FormItem label="车辆有效期:">
          <Input v-model="expireTime" size="small" disabled />
        </FormItem>
        <FormItem label="报停日期:" prop="suspendDate">
          <DatePicker
            v-model="formFields.suspendDate"
            :options="dateOptions"
            :editable="false"
            type="date"
            format="yyyy-MM-dd"
            placeholder="请输入报停日期..."
            style="width: 100%"
            size="small"
            @on-change="onSuspendDateChange"
          />
        </FormItem>
      </Form>
      <div style="font-size: 12px; text-align: right; color: #69c">
        <Icon type="md-information-circle" /> 车辆有效期将更新至报停日期、且只能退自报停日期之后的剩余时间。
      </div>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-lock"
        :loading="submit"
        @click="handleSuspend"
      >
        报停车辆
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
// import { dateFormat, isAfter } from '@/utils/util'
export default {
  name: 'VehicleSuspendDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 500
    },
    id: {
      type: Number,
      default: 0
    },
    vehicleNumber: {
      type: String,
      default: ''
    },
    expireTime: {
      type: String,
      default: ''
    }
  },
  data() {
    const _this = this
    return {
      loadingStatus: false,
      submit: false,
      formFields: {
        id: this.id,
        suspendDate: ''
      },
      dateOptions: {
        disabledDate(date) {
          const disabled = date && (
            date.valueOf() < Date.now() - 86400000 ||
            _this.expireTime && date.valueOf() > new Date(_this.expireTime).valueOf()
          )
          return disabled
        }
      }
    }
  },
  computed: {
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    ruleValidate() {
      return {
        suspendDate: [{ required: true, message: '报停日期不能为空' }]
      }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
    }
  },
  methods: {
    onSuspendDateChange: function(date) {
      this.formFields.suspendDate = date
    },
    resetForm() {
      this.formFields = { id: 0, suspendDate: '' }
    },
    onModeChange(e) {
      this.loadRefundAmount()
    },
    handleSuspend() {
      const _this = this
      this.$refs.suspendForm.validate((valid) => {
        if (!valid) { return }
        this.$Modal.confirm({
          title: '确认报停车辆么？',
          loading: true,
          render: (h, params) => {
            return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, this.vehicleNumber)])
          },
          onOk: function() {
            _this.submit = true
            const _that = this
            request({
              url: this.$config.apiContextPath + '/vehicle' + '/' + _this.id + '/action/suspend',
              params: {
                'suspendDate': _this.formFields.suspendDate
              },
              method: 'PUT'
            }).then(res => {
              this.$Notice.success({
                title: '车辆报停成功',
                desc: '车辆 `' + _this.vehicleNumber + '` 报停成功!'
              })
              _that.buttonLoading = false
              _this.closeModal(true)
              _this.submit = false
              this.$Modal.remove()
            }).catch(error => {
              this.$Notice.error({
                title: '车辆报停失败',
                desc: '车辆 `' + _this.vehicleNumber + '` 报停失败, 错误信息: ' + error
              })
              _this.submit = false
              _that.buttonLoading = false
            })
          },
          onCancel: function() {
          }
        })
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
